export interface Category {
  name: string;
  url: string;
  imagePrompt: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imagePrompt: "Premium sneakers and athletic footwear displayed on a clean white minimalist shelf, soft natural lighting from the left, editorial product photography style with warm neutral tones, simple elegant composition with subtle shadows on cream background",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imagePrompt: "Cozy oversized hoodie and knit sweater folded neatly on a light wooden surface, soft diffused daylight through sheer curtains, warm beige and cream tones, minimalist Scandinavian aesthetic with gentle texture details",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imagePrompt: "Stack of premium cotton t-shirts in neutral earth tones arranged artistically on a clean surface, soft morning light from window, editorial flat lay photography, minimalist composition with subtle fabric texture visible",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imagePrompt: "Stylish modern jacket hanging on a minimalist wooden hanger against a soft cream wall, gentle side lighting creating elegant shadows, high-end fashion editorial style, warm taupe and beige color palette with refined texture",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imagePrompt: "Well-tailored chino pants and casual shorts folded neatly on a light linen surface, soft natural window light, clean minimalist aesthetic, warm sand and earth tones, gentle fabric texture with subtle crease details",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imagePrompt: "Collection of stylish caps and beanies arranged on a clean white surface, soft diffused lighting from above, modern editorial product photography, neutral tones with subtle brand embroidery visible, minimalist composition",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imagePrompt: "Coordinated clothing sets displayed elegantly on a light cream background, soft natural lighting, high-end fashion editorial style, warm neutral color palette, harmonious arrangement with gentle texture and fold details",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imagePrompt: "Premium cotton underwear folded neatly on a soft linen surface, gentle diffused daylight, clean minimalist aesthetic, warm beige and cream tones, subtle fabric texture with elegant simplicity in composition",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imagePrompt: "Athletic jersey displayed flat on a clean light surface, soft natural lighting highlighting fabric texture, sport-inspired editorial photography, warm neutral background with subtle shadow details, minimalist composition",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imagePrompt: "Curated collection of fashion accessories including watches bracelets and sunglasses arranged on a cream surface, soft diffused daylight, editorial flat lay style, warm neutral tones with gentle reflections on metallic surfaces",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imagePrompt: "Elegant leather backpack and tote bag placed on a light wooden surface, soft natural side lighting, refined editorial product photography, warm cognac and cream tones, subtle leather grain texture visible in gentle light",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imagePrompt: "Premium leather belts coiled elegantly on a clean cream surface, soft diffused lighting from above, minimalist editorial photography, warm brown and tan tones, subtle metallic buckle reflections with gentle shadow details",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imagePrompt: "Elegant glass perfume bottles arranged on a light marble surface, soft natural window light creating gentle reflections, luxury editorial product photography, warm amber and cream tones, minimalist sophisticated composition",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imagePrompt: "Assorted lifestyle products and accessories displayed on a clean cream surface, soft natural lighting from side, editorial flat lay photography, warm neutral tones, eclectic yet harmonious arrangement with gentle shadow details",
  },
];